<div *ngIf="sites" ngbDropdown class="d-inline-block date-picker">
  <button class="btn btn-outline-primary" id="rangePicker" ngbDropdownToggle>{{displayedPreset}}</button>
  <div ngbDropdownMenu aria-labelledby="rangePicker">
    <a class="dropdown-item" (mouseover)="isBillingCollapsed = true" (click)="changePresetRange('currentWindow')" i18n>Current</a>
    <a class="dropdown-item" (mouseover)="isBillingCollapsed = true" (click)="changePresetRange('lastDay')" i18n>Last day</a>
    <a class="dropdown-item" (mouseover)="isBillingCollapsed = true" (click)="changePresetRange('last3days')" i18n>Last 3 days</a>
    <a class="dropdown-item" (mouseover)="isBillingCollapsed = true" (click)="changePresetRange('lastWeek')" i18n>Last week</a>
    <a class="dropdown-item" (mouseover)="isBillingCollapsed = true" (click)="changePresetRange('customRange')" i18n>Custom range...</a>
  </div>
</div>
<app-datepicker></app-datepicker>
